module.exports = __webpack_public_path__ + "49e495693286885f882419c0791fc649.jpg";